import { Page, TabItem, Tabs } from "@skailer-com/uikit";
import { useTitle } from "@/hooks/use-title.hook.ts";
import { DataProtectionTabRequests } from "@/pages/settings/data-protection/index/components/DataProtectionTabRequests.tsx";
import { DataProtectionTabSettings } from "@/pages/settings/data-protection/index/components/DataProtectionTabSettings.tsx";
import {
  DataProtectionSettingsProps,
  DataProtectionSettingsTabs,
} from "@/types/data-protection.types.ts";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export function DataProtectionSettings({ tab }: DataProtectionSettingsProps) {
  const { t } = useTranslation();
  useTitle(t("data_protection:data_protection"), t("common:settings"));

  const navigate = useNavigate();

  const handleTabChanged = (tabIndex: number) => {
    const urls = ["/settings/data-protection", "/settings/data-protection/requests"];

    navigate(urls[tabIndex]);
  };

  return (
    <Page>
      <Page.Header
        title={t("data_protection:data_protection")}
        showBack={true}
        navigateTo={"/settings"}
      ></Page.Header>
      <Page.Content>
        <Tabs
          onActiveTabChange={handleTabChanged}
          className={"px-16"}
          activeTab={tab == DataProtectionSettingsTabs.settings ? 0 : 1}
        >
          <TabItem title={t("common:settings")}>
            <DataProtectionTabSettings />
          </TabItem>
          <TabItem title={t("common:requests")}>
            <DataProtectionTabRequests />
          </TabItem>
        </Tabs>
      </Page.Content>
    </Page>
  );
}
